import { nextTick } from 'vue';
import { useToast } from 'primevue/usetoast';
import { TOAST_SAVE_LIFE } from '@/utils/constants.js';

// Generic row editor composable that encapsulates common row-editing helpers
// Used by both AdminReviewEntities.vue and AdminReviewNetworks.vue
export function useRowEditor(rowForm, editingRows) {
  const toast = useToast();

  const stopPrimeVueEvent = (e) => {
    try {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      if (e && typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (e?.originalEvent) {
        if (typeof e.originalEvent.preventDefault === 'function') e.originalEvent.preventDefault();
        if (typeof e.originalEvent.stopImmediatePropagation === 'function') e.originalEvent.stopImmediatePropagation();
      }
    } catch (_) {
      // ignore
    }
  };

  const getCurrentRowId = () => {
    return rowForm?.formData?.id ?? rowForm?.formData?.data?.id ?? null;
  };

  const reopenEditorForId = async (id) => {
    if (id == null) return false;
    try {
      await nextTick();
      editingRows.value = [id];
      return true;
    } catch (e) {
      return false;
    }
  };

  const showToast = ({ severity = 'info', summary = '', detail = '', life = TOAST_SAVE_LIFE, group = 'top-toast' } = {}) => {
    toast.add({ group, severity, summary, detail, life });
  };

  return {
    stopPrimeVueEvent,
    getCurrentRowId,
    reopenEditorForId,
    showToast,
  };
}

